import AboutPage from '../about/AboutPage';
import EditClubPage from './clubfinder/EditClubPage';
import InternClubfinder from './clubfinder/InternClubfinder';
import EditCoursePage from './coursePage/edit/EditCoursePage';
import InternRefreshsPage from './coursePage/starters/InternRefreshsPage';
import InternSpecialCoursesPage from './coursePage/starters/InternSpecialCoursesPage';
import InternTanzabendPage from './coursePage/starters/InternTanzabendPage';
import InternTCEAcademyPage from './coursePage/starters/InternTCEAcademyPage';
import InternTCEEventsPage from './coursePage/starters/InternTCEEventsPage';
import InternWorkshopsPage from './coursePage/starters/InternWorkshopsPage';
import InternYouthpartysPage from './coursePage/starters/InternYouthpartysPage';
import EditFerienPage from './DatesOverview/Edit/EditFerienPage';
import InternDatesOverview from './DatesOverview/InternDatesOverview';
import Intern404Page from './Intern404Page';
import InternWelcomePage from './InternWelcomePage';
import ReservationsPage from './Reservations/ReservationsPage';

const internRoutesConfig = [
  { path: '', Component: InternWelcomePage },
  { path: 'dates', Component: InternDatesOverview },
  { path: 'youthDates', Component: InternYouthpartysPage },
  { path: 'clubfinder', Component: InternClubfinder },
  { path: 'specialCourses', Component: InternSpecialCoursesPage },
  { path: 'refresh', Component: InternRefreshsPage },
  { path: 'tceevents', Component: InternTCEEventsPage },
  { path: 'workshops', Component: InternWorkshopsPage },
  { path: 'tceacademy', Component: InternTCEAcademyPage },
  { path: 'tanzabende', Component: InternTanzabendPage },
  { path: 'about', Component: AboutPage },
  { path: 'newCourse', Component: EditCoursePage },
  { path: 'newHoliday', Component: EditFerienPage },
  { path: 'newClub', Component: EditClubPage },
  { path: 'editCourse/:id', Component: EditCoursePage },
  { path: 'editHoliday/:id', Component: EditFerienPage },
  { path: 'editClub/:id', Component: EditClubPage },
  { path: 'reservations/:id', Component: ReservationsPage },
  { path: '*', Component: Intern404Page }
];

export default internRoutesConfig;
